/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Clear_Confirmation_ActionInputs */

const en_case_payment_clear_confirmation_action = /** @type {(inputs: Case_Payment_Clear_Confirmation_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove confirmation`)
};

const pt_br2_case_payment_clear_confirmation_action = /** @type {(inputs: Case_Payment_Clear_Confirmation_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover confirmação`)
};

/**
* | output |
* | --- |
* | "Remove confirmation" |
*
* @param {Case_Payment_Clear_Confirmation_ActionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_clear_confirmation_action = /** @type {((inputs?: Case_Payment_Clear_Confirmation_ActionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Clear_Confirmation_ActionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_clear_confirmation_action(inputs)
	return pt_br2_case_payment_clear_confirmation_action(inputs)
});